import { Outlet, createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { FormatProvider } from '@paige/format';
import { requireStaff } from '../auth/gate';
import { AppShell } from '../shell/AppShell';
import { AdminNav } from '../screens/admin/AdminNav';
import { hideTestsFor } from '../screens/admin/hide-tests';

/** Level 0: staff only, decided by the API's staff claim; wears the staff band and accent. */
export const Route = createFileRoute('/admin')({
  beforeLoad: ({ context, location }) =>
    requireStaff(context.auth, location.href).then((staff) => {
      // Before any admin page reads: whose "Hide test companies" choice applies.
      hideTestsFor(staff.id);
      return staff;
    }),
  component: AdminLayout,
});

function AdminLayout(): ReactNode {
  return (
    <FormatProvider>
      <AppShell staff>
        <AdminNav />
        <Outlet />
      </AppShell>
    </FormatProvider>
  );
}
